import { ContentBox, useBreadcrumbTitle } from "@msuite/ui/app-shell";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { useParams } from "react-router";
import { useTransferCarrier } from "@/hooks/use-transfer-carrier";
import { TransferCarrierGeneral } from "./transfer-carrier-general";
import { TransferCarrierHistory } from "./transfer-carrier-history";

export function TransferCarrier() {
	/** Hooks */
	const transferCarrierId = useParams().transferCarrierId as string;
	const { t } = useTranslation();
	const { transferCarrier } = useTransferCarrier(transferCarrierId);
	// The number, because it is what is painted on the device.
	useBreadcrumbTitle(transferCarrierId, transferCarrier ? String(transferCarrier.number) : null);

	/** Render */
	return (
		<ContentBox>
			<Tabs
				groups={[
					{
						name: "general",
						panels: [
							{
								label: t("general.general"),
								panel: () => <TransferCarrierGeneral transferCarrierId={transferCarrierId} />,
								cyId: "general-tab",
								errors: [],
							},
						],
					},
					{
						name: "details",
						panels: [
							{
								label: t("stock.transfer_carrier_history"),
								panel: () => <TransferCarrierHistory transferCarrierId={transferCarrierId} />,
								cyId: "history-tab",
								errors: [],
							},
						],
					},
				]}
			/>
		</ContentBox>
	);
}
